module.exports = __webpack_public_path__ + "static/img/2.a96194cd.png";